<script>
import SearchableSelect from '@/components/SearchableSelect';
import { notify } from '@/helpers/notify';
import { requiredIf } from 'vuelidate/lib/validators';

export default {
  name: 'Vericiler',
  components: { SearchableSelect },
  props: {
    list: { default: 0 },
    data: { default: 0 },
    groupName: { type: String, default: '' },
  },
  data() {
    return {
      vericiList: [],
      availableList: [],
      loading: false,
      saving: false,
      showAdd: false,
      addMode: 'select', // select | create
      selectedId: null,
      form: {
        name: '',
        type: 1,
        ssid: '',
        mac: '',
        ip: '',
        username: '',
        password: '',
        explaine: '',
      },
      submitted: false,
    };
  },
  validations: {
    selectedId: {
      required: requiredIf(function () {
        return this.showAdd && this.addMode === 'select';
      }),
    },
    form: {
      name: {
        required: requiredIf(function () {
          return this.showAdd && this.addMode === 'create';
        }),
      },
    },
  },
  computed: {
    modalTitle() {
      const name = this.groupName ? ` — ${this.groupName}` : '';
      return `Pop Altındaki Vericiler${name}`;
    },
    typeOptions() {
      return [
        { id: 1, name: 'AP' },
        { id: 2, name: 'LINK' },
      ];
    },
  },
  watch: {
    data() {
      this.resetAdd();
      this.loadList();
    },
  },
  methods: {
    loadList() {
      if (!this.list) return;
      this.loading = true;
      this.$http.post(`/transmitter/groups?verici=${this.list}`)
        .then(response => {
          this.vericiList = Array.isArray(response.data) ? response.data : [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    loadAvailable() {
      this.$http.post(`/transmitter?available_for=${this.list}`)
        .then(response => {
          const rows = Array.isArray(response.data) ? response.data : (response.data.data || []);
          this.availableList = rows.map(row => ({
            ...row,
            label: row.ip ? `${row.name} (${row.ip})` : row.name,
          }));
        });
    },

    openAdd() {
      this.showAdd = true;
      this.addMode = 'select';
      this.selectedId = null;
      this.form = {
        name: '',
        type: 1,
        ssid: '',
        mac: '',
        ip: '',
        username: '',
        password: '',
        explaine: '',
      };
      this.submitted = false;
      this.$v.$reset();
      this.loadAvailable();
    },

    resetAdd() {
      this.showAdd = false;
      this.selectedId = null;
      this.submitted = false;
      this.saving = false;
    },

    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.saving = true;

      if (this.addMode === 'select') {
        this.assignExisting();
      } else {
        this.createNew();
      }
    },

    assignExisting() {
      this.$http.put(`/transmitter/${this.selectedId}/assign-group`, {
        transmitter_group_id: this.list,
      }).then((resp) => {
        if (resp.data && resp.data.code && resp.data.code !== 100) {
          return notify.error(resp.data.message);
        }
        notify.success(resp.data.message || 'Verici POP noktasına eklendi');
        this.resetAdd();
        this.loadList();
        this.$emit('changed');
      }).finally(() => {
        this.saving = false;
      });
    },

    createNew() {
      this.$http.post('/transmitter/store', {
        ...this.form,
        transmitter_group_id: this.list,
      }).then((resp) => {
        if (resp.data && resp.data.code && resp.data.code !== 100) {
          return notify.error(resp.data.message);
        }
        notify.success(resp.data.message || 'Verici oluşturuldu');
        this.resetAdd();
        this.loadList();
        this.$emit('changed');
      }).finally(() => {
        this.saving = false;
      });
    },

    removeFromGroup(row) {
      this.$swal({
        title: 'POP noktasından çıkarılsın mı?',
        text: row.name,
        showCancelButton: true,
        cancelButtonText: 'İptal',
        confirmButtonText: 'Çıkar',
      }).then((result) => {
        if (!result.value) return;

        this.$http.put(`/transmitter/${row.id}/assign-group`, {
          transmitter_group_id: null,
        }).then((resp) => {
          notify.success(resp.data.message || 'Verici çıkarıldı');
          this.loadList();
          this.$emit('changed');
        });
      });
    },

    close() {
      this.resetAdd();
      this.$parent.$bvModal.hide('vericiler-scoped');
    },
  },
};
</script>

<template>
  <b-modal id="vericiler-scoped" :title="modalTitle" no-close-on-backdrop hide-footer size="lg">
    <div v-if="loading" class="text-center py-4 text-muted">Yükleniyor...</div>

    <div v-else>
      <div class="d-flex justify-content-between align-items-center mb-3" v-if="!showAdd">
        <span class="text-muted">Toplam <strong>{{ vericiList.length }}</strong> verici</span>
        <b-button variant="success" size="sm" @click="openAdd">
          <i class="bx bx-plus"></i> Verici Ekle
        </b-button>
      </div>

      <div v-if="showAdd" class="border rounded p-3 mb-3 bg-light">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <strong>Verici Ekle</strong>
          <button type="button" class="btn btn-sm btn-link" @click="resetAdd">Vazgeç</button>
        </div>

        <div class="btn-group mb-3 w-100">
          <button
            type="button"
            class="btn"
            :class="addMode === 'select' ? 'btn-primary' : 'btn-outline-primary'"
            @click="addMode = 'select'"
          >Eklilerden Seç</button>
          <button
            type="button"
            class="btn"
            :class="addMode === 'create' ? 'btn-primary' : 'btn-outline-primary'"
            @click="addMode = 'create'"
          >Yeni Ekle</button>
        </div>

        <form @submit.prevent="handleSubmit">
          <div v-if="addMode === 'select'">
            <label class="form-label">Mevcut Verici</label>
            <SearchableSelect
              v-model="selectedId"
              :options="availableList"
              label="label"
              :reduceFn="o => o.id"
              placeholder="Verici ara / seç..."
              searchable
            />
            <div
              v-if="submitted && $v.selectedId.$error"
              class="text-danger small mt-1"
            >Verici seçimi zorunludur.</div>
          </div>

          <div v-else>
            <div class="mb-2">
              <label class="form-label">Verici İsmi</label>
              <input
                v-model="form.name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.name.$error }"
                placeholder="Verici İsmi"
              >
              <div v-if="submitted && !$v.form.name.required" class="invalid-feedback d-block">
                Bu alanı doldurmak zorunludur.
              </div>
            </div>
            <div class="mb-2">
              <label class="form-label">Tip</label>
              <SearchableSelect
                v-model="form.type"
                :options="typeOptions"
                label="name"
                :reduceFn="o => o.id"
                placeholder="Tip seç..."
              />
            </div>
            <div class="row">
              <div class="col-md-6 mb-2">
                <label class="form-label">IP</label>
                <input v-model="form.ip" type="text" class="form-control" placeholder="IP">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label">MAC</label>
                <input v-model="form.mac" type="text" class="form-control" placeholder="MAC">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label">SSID</label>
                <input v-model="form.ssid" type="text" class="form-control" placeholder="SSID">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label">Username</label>
                <input v-model="form.username" type="text" class="form-control" placeholder="Username">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label">Password</label>
                <input v-model="form.password" type="text" class="form-control" placeholder="Password">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label">Açıklama</label>
                <input v-model="form.explaine" type="text" class="form-control" placeholder="Açıklama">
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <b-button type="submit" variant="success" :disabled="saving">
              <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
              {{ addMode === 'select' ? 'POP Noktasına Ekle' : 'Oluştur ve Ekle' }}
            </b-button>
          </div>
        </form>
      </div>

      <div class="table-responsive" v-if="!showAdd">
        <table class="table table-sm mb-0">
          <thead>
            <tr>
              <th>Verici Adı</th>
              <th>IP</th>
              <th>Açıklama</th>
              <th style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(stck, i) in vericiList" :key="`verici-${stck.id || i}`">
              <td>{{ stck.name }}</td>
              <td>{{ stck.ip || '-' }}</td>
              <td>{{ stck.explaine || '-' }}</td>
              <td class="text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  @click="removeFromGroup(stck)"
                >Çıkar</button>
              </td>
            </tr>
            <tr v-if="!vericiList.length">
              <td colspan="4" class="text-center text-muted py-3">Bu POP altında verici yok</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-3" v-if="!showAdd">
      <b-button variant="light" @click="close()">Kapat</b-button>
    </div>
  </b-modal>
</template>
